import { useQuery } from "@tanstack/react-query";
import { _axios } from "../utils/axios";
import { TApplication } from "./levelThreeApplication.hooks";

export const rejectedApplicationsKeyStore = {
  all: ["rejected-applications"] as const,
  lists: () => [...rejectedApplicationsKeyStore.all, "list"] as const,
  list: (page: number, limit: number, sort: string, sortVal: number, search: string, statuses: string[]) =>
    [...rejectedApplicationsKeyStore.lists(), { page, limit, sort, sortVal, search, statuses }] as const,
  counts: (search: string, statuses: string[]) =>
    [...rejectedApplicationsKeyStore.all, "count", { search, statuses }] as const,
};

export function useRejectedApplicationCounts({
  search,
  statuses,
}: {
  search?: string;
  statuses?: string[];
}) {
  return useQuery({
    queryKey: rejectedApplicationsKeyStore.counts(search || "", statuses || []),
    queryFn: () =>
      _axios.post<{
        success: true;
        data: number;
      }>("/rejected-applications/count", { search, statuses }).then((res) => res.data),
    staleTime: 10 * 60 * 1000,
    select: (d) => d.data,
  });
}

export function useRejectedApplications({
  page,
  limit,
  search,
  sort,
  sortVal,
  statuses,
}: {
  page: number;
  limit: number;
  search?: string;
  sort: string;
  sortVal: number;
  statuses?: string[];
}) {
  return useQuery({
    queryKey: rejectedApplicationsKeyStore.list(
      page,
      limit,
      sort,
      sortVal,
      search || "",
      statuses || []
    ),
    queryFn: () =>
      _axios.post<{
        success: true;
        hasMore?: boolean;
        data: any[];
      }>("/rejected-applications/list", {
        sort,
        sortVal,
        search,
        page,
        limit,
        statuses: statuses || [],
      }).then((res) => res.data),
    staleTime: 10 * 60 * 1000,
    select: (d) => d.data,
  });
}
